import { render, staticRenderFns } from "./CovidCancer.vue?vue&type=template&id=c2881cb4&scoped=true&"
import script from "./CovidCancer.vue?vue&type=script&lang=ts&"
export * from "./CovidCancer.vue?vue&type=script&lang=ts&"
import style0 from "./CovidCancer.vue?vue&type=style&index=0&id=c2881cb4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2881cb4",
  null
  
)

export default component.exports